import { CheckmarkFilled, ErrorFilled, Information } from '@carbon/react/icons';
import { InlineLoading, OverflowMenu } from '@carbon/react';
import { StatusItem } from 'pages/crm-tracts-subtracts/types';
import style from './workflow-status-popover.module.scss';

interface WorkflowStatusPopoverProps {
  'statusItems': StatusItem[];
  'overallStatus': string;
  'iconDescription'?: string;
  'ariaLabel'?: string;
  'data-testid'?: string;
}

export const WorkflowStatusPopover = ({
  statusItems,
  overallStatus,
  iconDescription = 'Show status',
  ariaLabel = 'Show status',
  'data-testid': dataTestId,
}: WorkflowStatusPopoverProps) => {
  // Determine which icon to render based on overall status
  const renderStatusIcon = () => {
    switch (overallStatus) {
      case 'processed':
        return <CheckmarkFilled className={style.statusIcon} />;
      case 'failed':
        return <ErrorFilled className={style.statusIconError} />;
      case 'processing':
      case 'pending':
      default:
        return (
          <InlineLoading status="active" className={style.statusIconPending} />
        );
    }
  };

  return (
    <div
      className={style.container}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <OverflowMenu
        renderIcon={renderStatusIcon}
        iconDescription={iconDescription}
        direction="bottom"
        menuOptionsClass={style.statusPopover}
        size="sm"
        aria-label={ariaLabel}
        data-testid={dataTestId}
      >
        {statusItems.map((status, index) => (
          <div
            key={index}
            className={style.statusItem}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            <span className={style.statusLabel}>{status.label}</span>
            <span className={style.statusValue}>
              {status.value}
              {status.details && (
                <div
                  className={style.statusInfoContainer}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Information className={style.statusInfoIcon} />
                  <div className={style.statusInfoTooltip}>
                    {status.details}
                  </div>
                </div>
              )}
            </span>
          </div>
        ))}
      </OverflowMenu>
    </div>
  );
};
